import { render, staticRenderFns } from "./SysCheckRuleList.vue?vue&type=template&id=3baa94da&scoped=true"
import script from "./SysCheckRuleList.vue?vue&type=script&lang=js"
export * from "./SysCheckRuleList.vue?vue&type=script&lang=js"
import style0 from "./SysCheckRuleList.vue?vue&type=style&index=0&id=3baa94da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baa94da",
  null
  
)

export default component.exports